import React from 'react';
import PropTypes from 'prop-types';
import RpcEndpoint from 'components/RpcEndpoint';
import {connect} from 'react-redux';
import {applyFilters} from 'state/cardFilter/cardFilterRpcActions';
import {analyticsTrack} from 'utilities/analytics';
import {ADOBE_ANALYTICS_EVENTS} from 'app/Analytics';
import {LOCAL} from 'app/JsRpcConstants';

class EmbedCardEndpoints extends React.Component {
  handleApplyFiltersCall = ({filters}) => {
    analyticsTrack(ADOBE_ANALYTICS_EVENTS.CARD__JS_API_FILTER, {
      card_id: this.props.cardId,
    });
    this.props.applyFilters(this.props.cardId, filters);
  };

  render() {
    return (
      <React.Fragment>
        <RpcEndpoint
          method={LOCAL.V1_FILTERS_APPLY}
          onCall={this.handleApplyFiltersCall}
        />
      </React.Fragment>
    );
  }
}

EmbedCardEndpoints.propTypes = {
  cardId: PropTypes.string.isRequired,
};

export default connect(
  null,
  {
    applyFilters,
  }
)(EmbedCardEndpoints);
